import React, { Component } from 'react';

const userResponseComponent = ({message,messageTime,is_feedback}) => {
    return(
        <div style={{overflow:'auto'}}>
            <ul  className="bubbles-black">
                {message && <div>
                    {is_feedback && message && message === 'GOOD_FEEDBACK'  &&
                    <li style={{textAlign:'center'}}>
                        <a href="javascript:void(0)" className="up">
                            <img src={`${process.env.PUBLIC_URL}/assets/images/like-white.svg`} width="20"/>
                        </a>
                        <span className="time">{messageTime.time_in_format}</span>
                    </li>}
                    {is_feedback  && message && message ==='BAD_FEEDBACK'  &&
                    <li style={{textAlign:'center'}}> 
                        <a href="javascript:void(0)" className="response-down display-block">
                            <img src={`${process.env.PUBLIC_URL}/assets/images/like-white.svg`} width="20"/>
                        </a>
                        <span className="time">{messageTime.time_in_format}</span>
                    </li>}
                    {message && !is_feedback && <li><p>{message}</p><span className="time">{messageTime.time_in_format}</span></li>}
                </div>}
            </ul>

        </div>

    )
}

export default userResponseComponent



// WEBPACK FOOTER //
// ./src/components/message-components/user-response.component.js